import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        account_name: Yup.string().required('This field is required'),
        account_number: Yup.string().required('This field is required'),
        bank_name: Yup.string().required('This field is required'),
        country: Yup.string().required('This field is required'),
        amount_usd: Yup.string().required('This field is required'),
    });
}
